import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PayOnlineRoutingModule } from './pay-online-routing.module';
import { PayOnlineDashboardComponent } from './pay-online-dashboard/pay-online-dashboard.component';
import { PaymentLinkComponent } from './payment-link/payment-link.component';
import { RouterModule } from '@angular/router';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SuccessOrFailureComponent } from './success-or-failure/success-or-failure.component';
import { SafePipePipe } from './safe-pipe.pipe';



@NgModule({
  declarations: [
    PayOnlineDashboardComponent,
    PaymentLinkComponent,
    SuccessOrFailureComponent,
    SafePipePipe
  ],
  imports: [
    CommonModule,
    PayOnlineRoutingModule,
    RouterModule,
    MatSelectModule,
    MatInputModule,
    MatAutocompleteModule,
    NgxSpinnerModule,
    MatOptionModule,
  ]
})
export class PayOnlineModule { }
